import { Flex, Container } from '@telescope/cassini-ui';
import { BingoGame } from './BingoGame';
import { Results } from './Results';
import { useAuth, Sponsor } from 'features';
import { BingoProvider } from '../providers';
import { APP_MAX_WIDTH } from 'utils';

export const BingoApp = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <BingoProvider>
      <Container as={Flex} direction="column" maxW={{ lg: APP_MAX_WIDTH.TABLET }}>
        <Flex mb={[14, 14, 16]} direction="column" flexGrow={2}>
          { !user.submitted ? <BingoGame /> : <Results /> }
        </Flex>

        <Sponsor />

      </Container>
    </BingoProvider>
  )
}
